import Config from "../../config/config";
import { axiosFunc } from "../commonFunction";
import {AppenData} from "../commonFunction"
const errMsg = (msg) => {
  return { status: false, message: msg.toString() };
};
export const Signon = async (data) => {
  try {
    let respData = await axiosFunc(
      {
        method: "GET",
        url: `${Config.v1Url}/user/getuser`,
      },
      data.data
    );
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ Signon ~ err:", err);
    return errMsg(err);
  }
};

export const getCategory = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getcategory`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCategory ~ err:", err);
    return errMsg(err);
  }
};

export const getNetwork = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getnetwork`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getNetwork ~ err:", err);
    return errMsg(err);
  }
};
export const getCoins = async (data) => {
  console.log("🚀 ~ getCoins ~ data:", data);
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getalltokens`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCoins ~ err:", err);
    return errMsg(err);
  }
};

export const getCoinDetail = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/gettokendetail`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCoinDetail ~ err:", err);
    return errMsg(err);
  }
};

export const getMarketpairlist = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getcryptomarketpair`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getMarketpairlist ~ err:", err);
    return errMsg(err);
  }
};

export const getCandlestick = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getcandlestick`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCandlestick ~ err:", err);
    return errMsg(err);
  }
};

export const getExchanges = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getexchanges`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getExchanges ~ err:", err);
    return errMsg(err);
  }
};

export const getExchageData = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getexchangedetail`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getExchanges ~ err:", err);
    return errMsg(err);
  }
};

export const getTickerlist = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/gettickers`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getTickerlist ~ err:", err);
    return errMsg(err);
  }
};

export const subscribe = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}/user/subscribe`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ subscribe ~ err:", err);
    return errMsg(err);
  }
};

export const getSocialLinkList = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getsociallink`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getSocialLinkList ~ err:", err);
    return errMsg(err);
  }
};

export const getQestions = async () => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/common/getquestion`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getQestions ~ err:", err);
    return errMsg(err);
  }
};

export const getAnswer = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/user/getanswer`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getAnswer ~ err:", err);
    return errMsg(err);
  }
};

export const getQuestion = async () => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}/common/getquestion`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getQuestion ~ err:", err);
    return errMsg(err);
  }
};

export const answerSave = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}/user/useranswer`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ answerSave ~ err:", err);
    return errMsg(err);
  }
};

export const userAnswerEdit = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}/user/useransweredit`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ userAnswerEdit ~ err:", err);
    return errMsg(err);
  }
};

export const userAssetSummit = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}/user/assetsubmit`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ userAssetSummit ~ err:", err);
    return errMsg(err);
  }
};

export const getHeaderData = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getheaderdata`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getHeaderData ~ err:", err);
    return errMsg(err);
  }
};

export const getCmsData = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getcms`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getHeaderData ~ err:", err);
    return errMsg(err);
  }
};

export const getCoinDetailAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getcoindetailfromcontract`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getHeaderData ~ err:", err);
    return errMsg(err);
  }
};

export const getRequestListAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getrequest`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getRequestListAxios ~ err:", err);
    return errMsg(err);
  }
};

export const editAssetAxios = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}user/editasset`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ editAssetAxios ~ err:", err);
    return errMsg(err);
  }
};

export const addEditFormLists = async (data) => {
  console.log("rrrrrrrrrrrrrrrrrrrr",data);
  
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}user/addEditFormLists`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ editAssetAxios ~ err:", err);
    return errMsg(err);
  }
};

export const EditFormLists = async (data) => {
  console.log("rrrrrrrrrrrrrrrrrrrr",data);
  
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}user/EditFormLists`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ editAssetAxios ~ err:", err);
    return errMsg(err);
  }
};

export const sendOtpforEmail = async (data) => {
  console.log("rrrrrrrrrrrrrrrrrrrr",data);
  
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}user/sendOtpforEmail`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ editAssetAxios ~ err:", err);
    return errMsg(err);
  }
};